module.exports = new __parcel__URL__("background.2ee6fce2.mp3").toString();